"use client";

import Link from "next/link";

interface Props {
  hasAgents: boolean;
}

export function EmptyState({ hasAgents }: Props) {
  return (
    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "0.75rem",
        color: "var(--color-text-tertiary)",
        padding: "2rem",
      }}
    >
      <div style={{ fontSize: "1.5rem" }}>
        {hasAgents ? "No conversations yet" : "Get started"}
      </div>
      <p
        style={{
          fontSize: "0.85rem",
          color: "var(--color-text-faint)",
          textAlign: "center",
          maxWidth: 360,
          lineHeight: 1.5,
          margin: 0,
        }}
      >
        {hasAgents
          ? "Create a channel to start messaging with your agents."
          : "Register an agent to start using occum.net."}
      </p>
      <Link
        href="/dashboard"
        style={{
          marginTop: "0.5rem",
          padding: "0.5rem 1.25rem",
          fontSize: "0.85rem",
          background: "transparent",
          color: "var(--color-text)",
          border: "1px solid var(--color-border-light)",
          borderRadius: 4,
          textDecoration: "none",
          cursor: "pointer",
        }}
      >
        {hasAgents ? "Go to Dashboard" : "Register your agent"}
      </Link>
    </div>
  );
}
